// @ts-strict-ignore
import { UserModel } from '@user/model/user.model';
import { Injectable } from '@angular/core';
import { ProjectOptionDefVO } from './vo/project.vo';
import { ProjectOptionDefService } from '../components/import-export/service/project-option-def.service';
import { ProjectOptionDefIds } from '../components/project/constants/project-option-def-ids';

@Injectable({ providedIn: 'root' })
export class ProjectUserModel {

  private _projectOptionDefs: ProjectOptionDefVO[] = [];
  private _projectGroupOptionDefs: ProjectOptionDefVO[] = [];

  private fallBackValues = new Map<string, Partial<ProjectOptionDefVO>>([
    [ProjectOptionDefIds.CUSTOM_MATERIAL_NUMBER, {maxLength: 35}],
  ]);

  constructor(
    private userModel: UserModel,
    private projectOptionDefService: ProjectOptionDefService
  ){}

  public getProjectOwnerId(): number {
    return this.userModel.user ? this.userModel.user.id : NaN;
  }

  public saveProjectOptionDefs(): void {
    if (this.userModel.userProfile?.isRegisteredUserAccount() && this.userModel.user) {
      this.projectOptionDefService.saveProjectOptionDefs(this.userModel.user.id, this.projectOptionDefs);
    }
  }

  public get projectOptionDefs(): ProjectOptionDefVO[] {
    return this._projectOptionDefs;
  }

  public set projectOptionDefs(projectOptionDefs: ProjectOptionDefVO[]) {
    this._projectOptionDefs = projectOptionDefs || [];
  }

  public get projectGroupOptionDefs(): ProjectOptionDefVO[] {
    return this._projectGroupOptionDefs;
  }

  public set projectGroupOptionDefs(projectGroupOptionDefs: ProjectOptionDefVO[]) {
    this._projectGroupOptionDefs = projectGroupOptionDefs || [];
  }

  public getProjectOptionDef(identifier: string): ProjectOptionDefVO | null {
    if (!this.projectOptionDefs || !identifier) {
      return null;
    }
    for (const projectOptionDef of this.projectOptionDefs) {
      if (projectOptionDef.identifier === identifier) {
        this.fillDefaults(projectOptionDef);
        return projectOptionDef;
      }
    }
    return null;
  }

  /** For each field that is null or undefined in the given ProjectOptionDefVO, check the fallBackValues and fill them in */
  private fillDefaults(poDef: ProjectOptionDefVO): ProjectOptionDefVO {
    const fallbackPoDef = this.fallBackValues.get(poDef.identifier);
    for (const key in poDef) {
      if (poDef[key] === undefined || poDef[key] === null) {
        if (fallbackPoDef[key] !== undefined) {
          poDef[key] = fallbackPoDef[key] as ProjectOptionDefVO[keyof ProjectOptionDefVO];
        }
      }
    }
    return poDef;
  }
}
